import React from "react";

/**
 * Set di avatar predefiniti basati su DiceBear (CDN gratuito).
 * Salvati come stringhe semplici: "avataaars:seed" oppure "initials"
 */
export const AVATAR_PRESETS = [
  { id: "avataaars:happy", seed: "happy",  label: "Allegro" },
  { id: "avataaars:cool",  seed: "cool",   label: "Cool" },
  { id: "avataaars:smart", seed: "smart",  label: "Smart" },
  { id: "avataaars:glasses", seed: "glasses", label: "Occhialuto" },
  { id: "avataaars:beard", seed: "beard",  label: "Barbuto" },
  { id: "avataaars:warrior", seed: "warrior", label: "Warrior" },
  { id: "fun-emoji:sun", seed: "sun", style: "fun-emoji", label: "Sole" },
  { id: "fun-emoji:moon", seed: "moon", style: "fun-emoji", label: "Luna" },
  { id: "fun-emoji:star", seed: "star", style: "fun-emoji", label: "Stella" },
  { id: "bottts:robot1", seed: "robot1", style: "bottts", label: "Robot blu" },
  { id: "bottts:robot2", seed: "robot2", style: "bottts", label: "Robot arancio" },
  { id: "bottts:robot3", seed: "robot3", style: "bottts", label: "Robot verde" },
];

const COLORS = ["FF7A29", "0A0A0A", "F59E0B", "10B981", "3B82F6", "8B5CF6", "EC4899", "EF4444"];

export function getAvatarUrl(avatar, fallbackName = "") {
  if (!avatar || avatar === "initials") return null;
  const parts = avatar.split(":");
  const style = parts.length > 1 ? parts[0] : "avataaars";
  const seed = parts[parts.length - 1] || fallbackName || "user";
  return `https://api.dicebear.com/8.x/${style}/svg?seed=${encodeURIComponent(seed)}&backgroundColor=FFF0E3,FFE4D6,FFD3B3`;
}

function getInitials(name = "", lastname = "") {
  return ((name?.[0] || "") + (lastname?.[0] || "")).toUpperCase() || "?";
}

function colorFromString(s = "") {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0;
  return COLORS[Math.abs(h) % COLORS.length];
}

/**
 * Component <Avatar />
 * props: avatar (string|null), name, lastname, size (px), className
 */
export default function Avatar({ avatar, name = "", lastname = "", size = 40, className = "", testId }) {
  const url = getAvatarUrl(avatar, `${name}${lastname}`);
  if (url) {
    return (
      <img
        src={url}
        alt={`${name} ${lastname}`}
        width={size}
        height={size}
        loading="lazy"
        data-testid={testId}
        className={`rounded-full object-cover bg-[#FFF0E3] ${className}`}
        style={{ width: size, height: size }}
        onError={(e) => { e.target.style.display = "none"; }}
      />
    );
  }
  const initials = getInitials(name, lastname);
  const color = colorFromString(`${name}${lastname}`);
  return (
    <div
      data-testid={testId}
      className={`rounded-full text-white flex items-center justify-center font-bold ${className}`}
      style={{ width: size, height: size, backgroundColor: `#${color}`, fontSize: size * 0.4 }}
    >
      {initials}
    </div>
  );
}
